import { Fragment, useCallback, useEffect, useState } from "react";
import { Breadcrumbs } from "../../../AbstractElements";
import { Apps, Contacts } from "../../../Constants/Constants";
import { useAppDispatch } from "../../../ReduxToolkit/Hooks";
import { fetchContacts } from "../../../ReduxToolkit/Reducers/ContactReducer";
import { Container, Row } from "reactstrap";
import LeftContactAside from "./LeftContactAside/LeftContactAside";
import RightContactAside from "./RightContactAside/RightContactAside";

const ContactsContainer = () => {
  const dispatch = useAppDispatch();
  const [activeTab, setActiveTab] = useState(1);
  const changeTab = useCallback((tab: number) => {
    setActiveTab(tab);
  }, []);
  useEffect(() => {
    dispatch(fetchContacts());
  }, [dispatch]);
  return (
    <Fragment>
      <Breadcrumbs mainTitle={Contacts} parent={Apps} />
      <Container fluid>
        <div className="email-wrap bookmark-wrap">
          <Row>
            <LeftContactAside activeTab={activeTab} setActiveTab={setActiveTab} changeTab={changeTab} />
            <RightContactAside activeTab={activeTab} />
          </Row>
        </div>
      </Container>
    </Fragment>
  );
};

export default ContactsContainer;
